export default __webpack_public_path__ + "static/media/scenario3_table.7cd1e360.svg";